<template>
  <v-layout fill-height column class="text-center">
    <!-- <div class="pt-9 text-center" v-if="!timeCmpl">
        <div class="d-flex justify-space-between mb-23 px-5">
            <v-btn icon class="btn-play" @click="muteControl"><Mute :mute="mute"/></v-btn>
            <v-btn icon class="btn-play" @click="playControl"><Play :play="play"/></v-btn>
        </div>
        <div class="mb-8"><span class="fs-40">05:00</span></div>
        <div class="fs-18" v-html="content"></div>
        <v-btn-toggle v-model="toggle" class="mt-25">
            <v-btn depressed class="btn-click">Click!</v-btn>
        </v-btn-toggle>
    </div> -->
    <template v-if="!timeCmpl && !cmplt">
      <v-container fluid class="pb-0">
        <div class="solution-timer-controller">
          <div class="left">
            <v-btn icon class="btn-play" @click="muteControl"><Mute :mute="mute"/></v-btn>
          </div>
          <v-spacer />
          <div class="right">
            <v-btn icon class="btn-play" @click="playControl"><Play :play="play"/></v-btn>
          </div>
        </div>
      </v-container>
      <v-layout fill-height column justify-center>
        <v-container fluid>
          <div class="solution-timer-controller">
            <div class="time">{{ resTimeData }}</div>
          </div>
        </v-container>
        <v-layout flex-fill class="pos-relative">
          <v-container class="pos-absolute text-pre-line py-0" style="height: 100%; overflow-x: hidden; overflow-y: auto;">
            {{ textarea }}
          </v-container>
        </v-layout>
      </v-layout>
      <v-container fluid class="pb-0">
        <v-btn-toggle v-model="toggle">
          <v-btn v-if="!play" depressed @click="timeCheck" class="btn-click">Click!</v-btn>
          <v-btn v-else depressed class="btn-click-disable">Click!</v-btn>
        </v-btn-toggle>
      </v-container>
    </template>
    <template v-else>
      <div class="question">결과 확인</div>
      <div class="answer flex-grow-0">
        <!-- 3으로변경 -->
        <v-row class="immersion-time-result">
          <v-col cols="2" sm="4"
                 class="label">횟수</v-col>
          <v-col cols="10" sm="7"
                 class="text">
            <span class="cnt">{{timeCheckCnt}}</span>
            <span class="unit">회</span>
          </v-col>
          <v-col cols="2" sm="4"
                 class="label align-start">시점</v-col>
          <v-col cols="10" sm="7" md="5" lg="4"
                 class="text">
            <v-row class="immersion-time-list">
              <v-col v-for="n in timeCheckData.length" :key="n"
                     cols="4" sm="3"
                     class="immersion-time-list-item"
                     v-show="timeCheckData[n-1]"
              >{{ (timeCheckData[n-1]) ? timeCheckData[n-1] : '비었으' }}</v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </template>
    <v-footer app fixed color="white" class="content-footer">
      <FooterBtnsNext  @before="$emit('before')" @next="setMemberReply" :current="current" :total="total" :disabledNext="disabledNext"/>
    </v-footer>
  </v-layout>
</template>
<script>
import Play from '@/components/icons/Play'
import Mute from '@/components/icons/Mute'
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
import store from '../../../store'
import utils from '../../../utils/utils.js'
export default {
  props:["current","total","unitUseNo","unitDtlUseList","freeYn","cmpltYn","unitDtlUseNo","unitDtlPageSeq"],
  data: ()=> ({
    play: false,
    mute: false,
    toggle: null,
    min:0,
    sec:0,
    timeCounter : 0,
    resTimeData : '',
    timeCheckData:[],
    timeCheckCnt:0,
    timeCmpl:false,
    textarea:'',
    disabledNext:true,
    free: 'N',
    cmplt:false,
    ques:[],
    replyArr:[],
    replyObjArr:[],
    userReplyNo:[0,0],
    userReply:[],
    // audio: new Audio('http://www.hochmuth.com/mp3/Boccherini_Concerto_478-1.mp3'),
    audio: '',
  }),
  components:{
    Play,
    Mute,
    FooterBtnsNext,
  },
  computed: {
  },
  created () {
    this.getUnitDetailUse()
  },
  methods:{
    async getUnitDetailUse () {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = (this.cmpltYn === 'true' || this.cmpltYn === true) ? true : false
      // this.cmplt = true
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo':this.unitDtlUseNo[this.current-1]},
            {'unitDtlPageSeq':this.unitDtlPageSeq[this.current-1]},
            {'freeYn':this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
          .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
            //   this.ques.push(quesEl.ques)
              if (quesEl.timeType == '02') {
                this.min = quesEl.timeSet.substr(0,2)
                this.sec = quesEl.timeSet.substr(2,2)
              }

              // bgm 있는경우
              if(quesEl.musicAtchNo > 0 && !this.cmplt){
                // this.audio = new Audio('http://www.hochmuth.com/mp3/Boccherini_Concerto_478-1.mp3')
                this.audio = new Audio(utils.File.getDownUrl(quesEl.musicAtchFileName))
                this.audioPlay()
              }

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl,j) => {
                // this.userReplyNo[i+j] = userReplyEl.memberUnitDtlReplyUseNo
                if(j == 0){
                  this.textarea = userReplyEl.reply
                } else if(j == 1){
                    this.min = userReplyEl.reply.substr(0,2)
                    this.sec = userReplyEl.reply.substr(2,2)
                } else if(j > 1){
                    // 완료시에는 결과 바로 보여줌
                    if(this.cmplt){
                        if(j == 2){
                            this.timeCheckCnt = userReplyEl.reply
                        }else{
                            this.timeCheckData.push(userReplyEl.reply)
                        }
                        this.timeCmpl = true
                        this.disabledNext = false
                    }
                }
              });

              // 초변환
              this.timeCounter = (parseInt(this.min) * 60) + parseInt(this.sec)

            });

          } else {
              console.log(res.msg)
              // this.answer = [];
          }
          })
          .catch(error => {
              console.error(error)
              // this.answer = [];
          })
          .finally(() => {
            this.start()
          })
    },
    async setMemberReply () {

      if(!this.cmplt){ // 완료상태가 아닐때만 저장
        let replyObj = this.replyObjArr[2]
        this.userReply[0] = {
                                unitId: replyObj.unitId,
                                sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

                                memberUnitDtlReplyUseNo: 0,
                                // unitUseNo: replyObj.unitUseNo,
                                unitNo: replyObj.unitNo,
                                // unitDtlUseNo: replyObj.unitDtlUseNo,
                                unitDtlNo: replyObj.unitDtlNo,
                                // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
                                unitDtlQuesNo: replyObj.unitDtlQuesNo,
                                // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
                                unitDtlReplyNo: replyObj.unitDtlReplyNo,
                                userKey: this.$store.state.auth.authUser.userKey,
                                reply: this.timeCheckCnt,
                                // score: score/10,
                                freeYn: this.free,
                                unitType: "07"
                              }
        this.timeCheckData.forEach((timeCheck,i) => {
          this.userReply[i+1] = {
                                unitId: replyObj.unitId,
                                sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

                                memberUnitDtlReplyUseNo: 0,
                                // unitUseNo: replyObj.unitUseNo,
                                unitNo: replyObj.unitNo,
                                // unitDtlUseNo: replyObj.unitDtlUseNo,
                                unitDtlNo: replyObj.unitDtlNo,
                                // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
                                unitDtlQuesNo: replyObj.unitDtlQuesNo,
                                // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
                                unitDtlReplyNo: replyObj.unitDtlReplyNo,
                                userKey: this.$store.state.auth.authUser.userKey,
                                reply: timeCheck,
                                // score: score/10,
                                freeYn: this.free,
                                unitType: "07"
                              }
        })

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList',this.userReply))
              .then(res => {
                if (res.success) {
                    setTimeout(() => this.$emit('next'), 500); // 저장한 이후
                } else {
                    console.log(res.msg)
                }
              })
              .catch(error => {
                console.error(error)
              })
              .finally(() => {
              })
      } else {
        this.$emit('next')
      }
    },
    playControl(){
        this.play = !this.play;

        if(this.play){
            this.timeStop()
        } else{
            this.reStart()
        }
    },
    start() {
      // 1초에 한번씩 start 호출
      this.polling = setInterval(() => {
        // this.timeCounter-- //1 감소
        this.resTimeData = this.prettyTime()
        this.timeCounter-- //1 감소
        if (this.timeCounter < 0) this.timeStop()

      }, 1000)
    },
    // 시간 형식으로 변환 리턴
    prettyTime() {
      let time = this.timeCounter / 60
      let minutes = parseInt(time)
      let secondes = Math.round((time - minutes) * 60)
      return this.pad(minutes, 2) + ":" + this.pad(secondes, 2)
    },
    // 2자리수로 만들어줌 09,08...
    pad(n, width) {
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
    },
    timeStop() {
      clearInterval(this.polling)
      if (this.timeCounter <= 0){
        // 시간완료 페이지 div 전환처리
        this.timeCmpl = true
        this.disabledNext = false
        this.audioPause()
      }
    },
    // 재실행
    reStart() {
      clearInterval(this.polling)
      this.start()
    },
    // 클릭시 시간저장
    timeCheck(){
        this.timeCheckData.push(this.resTimeData)
        this.timeCheckCnt = this.timeCheckData.length
    },
    muteControl(){
        this.mute = !this.mute;
        if(!this.mute){
          this.audioPlay()
        } else{
          this.audioPause()
        }
    },
    audioPlay(){
      if(this.audio != '') this.audio.play();
    },
    audioPause(){
      if(this.audio != '') this.audio.pause();
    },
  },
  beforeDestroy() {
    clearInterval(this.polling)
  }
}
</script>
<style lang="scss" scoped>
::v-deep.v-btn-toggle:not(.v-btn-toggle--group){
    // .v-btn.btn-click{
    //     width: 76px !important;
    //     height: 76px !important;
    //     border-radius: 50%  !important;
    //     background: #E6E8EA !important;
    //     border-color: #E6E8EA !important;
    //     text-transform: none;
    //     &.v-item--active{
    //         background: $color-main !important;
    //         color: #fff;
    //     }
    // }
    .v-btn.btn-click{
        width: 76px !important;
        height: 76px !important;
        border-radius: 50%  !important;
        border-color: #E6E8EA !important;
        text-transform: none;
        background: $color-main !important;
        color: #fff
    }
    .v-btn.btn-click-disable{
        width: 76px !important;
        height: 76px !important;
        border-radius: 50%  !important;
        background: #E6E8EA !important;
        border-color: #E6E8EA !important;
        text-transform: none;
    }
}
</style>
